export default __webpack_public_path__ + "static/media/DwijendraTripathi.6f430d12.png";